"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowIcon = function ArrowIcon(_ref) {
  var isOpen = _ref.isOpen;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    preserveAspectRatio: "none",
    width: 16,
    fill: "transparent",
    stroke: "#979797",
    strokeWidth: "1.1px",
    transform: isOpen ? 'rotate(180)' : null
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,6 L10,15 L19,6"
  }));
};

var _default = ArrowIcon;
exports["default"] = _default;